const data = [

    {
      id: 1,
      question: "who is the host of game ABC(Aap Banenge Crorepati)?",
      answers: [
        {
          text: "A :   Iron Man",
          correct: false,
        },
        {
          text: "B :   Abhishek Bhatt",
          correct: true,
        },
        {
          text: "C :   Robert Downey Jr",
          correct: false,
        },
        {
          text: "D :   Rodie",
          correct: false,
        },
      ],
    },
    {
      id: 2,
      question: "What is the official currency of India?",
      answers: [
        {
          text: "A:   Paisa",
          correct: false,
        },
        {
          text: "B:  Pound",
          correct: false,
        },
        {
          text: "C:   Rupee",
          correct: true,
        },
        {
          text: "D:  Rokda",
          correct: false,
        },
      ],
    },
    {
      id: 3,
      question: "Who is the current Prime Minister of India ?",
      answers: [
        {
          text: "A :  Narendra Modi",
          correct: true,
        },
        {
          text: "B :  Arvind Kejriwal",
          correct: false,
        },
        {
          text: "C :  Rahul Gandhi",
          correct: false,
        },
        {
          text: "A :  Amit Shah",
          correct: false,
        },
      ],
    },
    
    {
      id: 4,
      question: "Kattapa ne kisey mara?",
      answers: [
        {
          text: "A :   Bhalal Dev",
          correct: false,
        },
        {
          text: "B :   Bahubali",
          correct: true,
        },
        {
          text: "C :   Mahishmati",
          correct: false,
        },
        {
          text: "D :  Rani Maa",
          correct: false,
        },
      ],
    },
 {
    id: 5,
    question: "Who is the CEO of SpaceX company?",
    answers: [
      {
        text: "A :   Jack Dorsey",
        correct: false,
      },
      {
        text: "B :   Jeff Bezos",
        correct: false,
      },
      {
        text: "C :   Jack Ma",
        correct: false,
      },
      {
        text: "D :  Elon Musk",
        correct: true,
      },
    ],
  },

  {
    id: 6,
    question: "how many Continents are there on earth?",
    answers: [
      {
        text: "A :   5",
        correct: false,
      },
      {
        text: "B :   7",
        correct: true,
      },
      {
        text: "C :   6",
        correct: false,
      },
      {
        text: "D :  8",
        correct: false,
      },
    ],
  },

  {
    id: 7,
    question: "Who is called 'Master Blaster' in cricket sports?",
    answers: [
      {
        text: "A :   Sourav Ganguly",
        correct: false,
      },
      {
        text: "B :   Suresh Raina",
        correct: false,
      },
      {
        text: "C :   Sachin Tendulkar",
        correct: true,
      },
      {
        text: "D :  Saina Nehiwal",
        correct: false,
      },
    ],
  },
  ];

  export default data;